// @flow
import React from 'react';
import { connect } from 'react-redux';

import { BottomNavigationItem } from 'material-ui/BottomNavigation';
import FontIcon from 'material-ui/FontIcon';
import IconButton from 'material-ui/IconButton';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import { ListItem } from 'material-ui/List';

import FeatureToggle from 'components/FeatureToggle';

import {
  loadUserTemplates,
  saveUserTemplate,
  deleteUserTemplate,
} from 'actions/userTemplates';
import { drawingFinished } from 'actions/drawOverlay';
import { setFitBounds } from 'actions/map';

import fetch from 'utils/fetch';

import type { UserTemplate } from 'reducers/userTemplates';
import { isFeatureDisabled } from '../../utils/auth';

type Props = {
  drawingFinished: Function,
  setFitBounds: Function,
  loadUserTemplates: Function,
  saveUserTemplate: Function,
  deleteUserTemplate: Function,

  templates: Array<UserTemplate>,

  appInDrawMode: boolean,
  drawOverlayHasFeature: boolean,
  style: any,
  browser: any,
};

type State = {
  anchorEl: ?EventTarget,
  open: boolean,
};

const getStyles = ({ appInDrawMode, drawOverlayHasFeature, browser }) => ({
  popover: {
    maxWidth: '450px',
    overflow: 'auto',
    ...(browser.lessThan.medium && { maxWidth: '100vw' }),
  },
  menu: {
    maxWidth: '450px',
    ...(browser.lessThan.medium && { maxWidth: '100vw' }),
  },
  listItem: {
    maxWidth: '450px',
    ...(browser.lessThan.medium && { maxWidth: '100vw' }),
  },
  fabSecondary: {
    position: 'fixed',
    bottom: 160,
    right: 12,
    ...(drawOverlayHasFeature
      ? {}
      : { boxShadow: '0 0 5px rgba(0, 0, 0, .25)' }),
  },
});

class SavedTemplatesPopover extends React.Component<Props, State> {
  state = {
    anchorEl: null,
    open: false,
  };

  componentWillMount() {
    this.props.loadUserTemplates();
  }

  renderAirspaceList() {
    const { templates, deleteUserTemplate, browser } = this.props;
    const styles = getStyles({ browser });
    return templates.map((t, i) => (
      <ListItem
        key={`draw-toolbar__template--${i}`}
        primaryText={t.properties.name}
        secondaryText={t.properties.saved}
        style={styles.listItem}
        rightIconButton={
          <IconButton
            iconClassName="material-icons"
            tooltip="Törlés"
            onClick={() => deleteUserTemplate(t.id)}
          >
            delete
          </IconButton>
        }
        onClick={() => {
          this.props.drawingFinished(t);
          this.props.setFitBounds(t.properties.bbox);
          this.setState({ open: false });
        }}
      />
    ));
  }

  renderEmptyMessage() {
    return (
      <ListItem
        disabled
        leftIcon={<FontIcon className="material-icons">info</FontIcon>}
        primaryText="Még nincsenek mentett sablonok"
        secondaryText={
          <span>
            Rajzoljon egy alakzatot, vagy kattintson a térképen egy<br />
            légtérre, és válassza a „Mentés sablonként” lehetőséget.
          </span>
        }
        secondaryTextLines={2}
      />
    );
  }

  render() {
    const {
      appInDrawMode,
      drawOverlayHasFeature,
      templates,
      saveUserTemplate,
      style,
      browser,
    } = this.props;
    const { open, anchorEl } = this.state;

    const styles = getStyles({ appInDrawMode, drawOverlayHasFeature, browser });
    return (
      <React.Fragment>
        <BottomNavigationItem
          key={`draw-toolbar-item-templates`}
          className={`draw-tools-tour__step-templates`}
          label={browser.lessThan.medium ? 'Sablonok' : 'Mentett sablonok'}
          tooltip="Korábban mentett sablonok"
          icon={<FontIcon className="material-icons">cached</FontIcon>}
          style={style}
          onClick={(e: Event) => {
            this.setState({
              anchorEl: e.currentTarget,
              open: !this.state.open,
            });
          }}
        />
        {!isFeatureDisabled('saved_templates') && (
          <Popover
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
            targetOrigin={{ horizontal: 'left', vertical: 'bottom' }}
            onRequestClose={() => this.setState({ open: false })}
            style={styles.popover}
          >
            <Menu style={styles.menu}>
              {templates.length
                ? this.renderAirspaceList()
                : this.renderEmptyMessage()}
            </Menu>
          </Popover>
        )}

        {appInDrawMode && !isFeatureDisabled('saved_templates') && (
          <FeatureToggle flag="hasSubscription">
            <FloatingActionButton
              className="draw-tools-tour__step-submit"
              style={styles.fabSecondary}
              disabled={!drawOverlayHasFeature}
              onClick={() => saveUserTemplate()}
              backgroundColor="white"
              iconStyle={drawOverlayHasFeature ? { color: 'black' } : {}}
              tooltip="Rajz mentése sablonként"
            >
              <FontIcon className="material-icons" color="black">
                save
              </FontIcon>
            </FloatingActionButton>
          </FeatureToggle>
        )}
      </React.Fragment>
    );
  }
}

export default connect(
  ({
    drawOverlay: { appInDrawMode, feature },
    userTemplates: { templates },
    browser,
  }) => ({
    appInDrawMode,
    drawOverlayHasFeature: !!feature,
    templates,
    browser,
  }),
  {
    drawingFinished,
    setFitBounds,
    loadUserTemplates,
    saveUserTemplate,
    deleteUserTemplate,
  }
)(SavedTemplatesPopover);



// WEBPACK FOOTER //
// ./components/DrawToolbar/SavedTemplatesPopover.js